export default __webpack_public_path__ + "static/media/All-Purpose-Paint.28626b66.jpg";